import React from 'react';
import usePermission from '../../../utils/hooks/permissionHooks/usePermission';
import {
  SecondaryNavContainer,
  SecondaryNavLinks,
  SecondaryNavSubTitle,
} from '../../../components/SecondaryNav';
import {
  dictionaryCustomDataNavLinks,
  dictionaryWarehouseDataNavLinks,
} from './utils';

const DictionaryNav = () => {
  const { checkIsPermitted } = usePermission();

  const warehouseDataNavLinks = dictionaryWarehouseDataNavLinks.map((link) => {
    const isPermitted = link?.permissionKeys
      ? checkIsPermitted({
          requiredPermissionKeys: link.permissionKeys,
        })
      : true;
    return {
      ...link,
      isPermitted,
    };
  });

  const customDataNavLinks = dictionaryCustomDataNavLinks.map((link) => {
    const isPermitted = link?.permissionKeys
      ? checkIsPermitted({
          requiredPermissionKeys: link.permissionKeys,
        })
      : true;
    return {
      ...link,
      isPermitted,
    };
  });

  return (
    <SecondaryNavContainer heading={'Dictionary'}>
      <SecondaryNavSubTitle subTitle={'Warehouse Data'} />
      <SecondaryNavLinks links={warehouseDataNavLinks} />
      <SecondaryNavSubTitle subTitle={'Catalog'} />
      <SecondaryNavLinks links={customDataNavLinks} />
    </SecondaryNavContainer>
  );
};

export default DictionaryNav;
